angular.module('app').component('adminPageHeader', {
    templateUrl: 'page-header.html',
    transclude: true
});
